import type { SVGProps } from 'react';

const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={20}
    viewBox='0 0 20 20'
    width={20}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M9.558 6.558a.625.625 0 0 1 .884 0l5 5a.625.625 0 1 1-.884.884L10 7.884l-4.558 4.558a.625.625 0 1 1-.884-.884z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);
export default SvgArrowUp;
